<template>
  <BaseLayout>
    <RevenueIndex />
  </BaseLayout>
</template>

<script>
import RevenueIndex from '@/composites/transaction/revenue/index/Index.vue'

export default {
  name: 'RevenueIndexPage',

  components: {
    BaseLayout: () => import('@/views/shared/BaseLayout.vue'),
    RevenueIndex,
  },
}
</script>
